export {default as quadtree} from "./src/quadtree";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-quadtree/index.js
// module id = 70
// module chunks = 0